import { ISearchFilterLicenceRequest } from 'models/searchFilter';
import { createSearchFilterLicence } from 'requests/searchFilter';

interface ISavePreset {
  name: string;
  emailNotificationEnabled: boolean;
  notificationEnabled: boolean;
  body: ISearchFilterLicenceRequest;
}

export const useSavePreset = () => {
  const savePreset = ({
    name,
    emailNotificationEnabled,
    notificationEnabled,
    body,
  }: ISavePreset) =>
    createSearchFilterLicence(
      name,
      emailNotificationEnabled,
      notificationEnabled,
      body as ISearchFilterLicenceRequest,
    );

  return { savePreset };
};
